import routerOptions0 from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}